import XIcon from "@mui/icons-material/Close"
import {
  Dialog,
  Stack,
  Typography,
  IconButton,
  Box,
  DialogContent,
  Button,
  Divider,
} from "@mui/material"
import { DialogProps } from "./types"
import { z } from "zod"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import ControlledTextInput from "@/components/controlledInputs/ControlledTextInput"

interface ScheduleDialogProps extends DialogProps {}

const scheduleFormSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  company: z.string(),
  contactTime: z.string(),
  contactDate: z.string(),
  category: z.string(),
  description: z.string(),
})
export type ScheduleFormDataType = z.infer<typeof scheduleFormSchema>
const defaultValues: ScheduleFormDataType = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  company: "",
  contactTime: "",
  contactDate: "",
  category: "",
  description: "",
}

export default function ScheduleDialog({
  isOpen,
  closeDialog,
}: ScheduleDialogProps) {
  function handleClose() {
    closeDialog()
  }

  const {
    // handleSubmit,
    // reset,
    control,
    // setValue,
    // formState: { errors },
  } = useForm<ScheduleFormDataType>({
    resolver: zodResolver(scheduleFormSchema),
    defaultValues: defaultValues,
  })
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minWidth={"500px"}
        pl={3}
        pr={1}
        py={1}
        sx={{
          backgroundColor: "white",
          color: "black",
        }}
      >
        <Typography>Schedule</Typography>
        <Box>
          <IconButton color="inherit" onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Box>
      </Stack>
      <Divider sx={{ padding: 2 }} />
      <DialogContent>
        <form action="https://formsubmit.co/info@843hub.com" method="POST">
          <Typography>We enjoy helping others grow.</Typography>
          <Divider sx={{ paddingY: 2 }} />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="firstName"
                label="First Name"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="lastName"
                label="Last Name"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="email"
                label="Email"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="phone"
                label="Phone"
                variant="filled"
              />
            </Stack>
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="company"
                label="Company"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="contactTime"
                label="Best Time To Contact"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="contactDate"
                label="Best Date To Contact"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="category"
                label="Category"
                variant="filled"
              />
            </Stack>
          </Box>
          <Box paddingY={2}>
            <ControlledTextInput
              control={control}
              name="description"
              label="Description"
              variant="filled"
              multiline={true}
              formInputStyling={{ width: "100%" }}
            />
          </Box>
          <Divider />
          <Typography sx={{ paddingTop: 2 }}>
            If our team is unable to talk at the time requested, we will reach
            out ahead of time to schedule another date that works well for both
            of us.
          </Typography>
          <Divider sx={{ paddingTop: 2 }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            mt={5}
          >
            <Button variant="text" color="inherit" onClick={closeDialog}>
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => {
                closeDialog()
              }}
            >
              Send
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  )
}
